import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {HandleLoginHeader} from "./login";
import Radio from "@atoms/radio";
import ButtonBase from "@atoms/button.base";
import CircleLoading from "../lotties/circle_loading";
import Captcha from "./captcha";
import {isEmpty} from "../../helpers/helpers";


function SignUpType({level, show, setShow, handleContinue, fields, setFields, handleRegister, handleForceRefreshCaptcha, handleCaptchaChange}) {
    let types = [
        {label: 'مالک / خریدار', value: 'normal'},
        {label: 'مشاور املاک', value: 'realtor'},
        {label: 'مدیر دفتر املاک', value: 'agency'},
    ];

    const [signUpType, setSignUpType] = useState('normal');

    useEffect(() => {
        const handleUserKeyPress = (event) => {
            const {key, keyCode} = event;
            if (show && keyCode === 13) {
                if (level.sing_up_type) {
                    handleSingUp();
                }
            }
        };
        window.addEventListener('keydown', handleUserKeyPress);
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress);
        };
    });

    useEffect(() => {
        if (!isEmpty(fields.captcha.token) && fields.captcha.require) {
            setFields(state => ({
                ...state,
                ['sing_up_type']: {value: signUpType, error: '', loading: false},
            }));
        }
    }, [fields.captcha])

    const handleChange = (event) => {
        const value = event.target.value;
        setSignUpType(value);
    };

    const handleSingUp = () => {
        setFields(state => ({
            ...state,
            ['sing_up_type']: {value: signUpType, error: '', loading: true},
        }));

        const to_level = (signUpType === 'normal') ? 'normal' : 'sign_up_realtor';
        handleRegister(to_level, (signUpType === 'normal'));
    };

    return (
        <Container show={level.sing_up_type}>
            <HandleLoginHeader title="نوع کاربری" close={() => setShow(false)} back={() => handleContinue('mobile')}/>

            <div className="pt-32">
                {
                    types.map((type, key) =>
                        <Radio name="sing_up_types" key={key} id={type.value} value={type.value} label={type.label} checked={(type.value === signUpType)} onChange={(e) => handleChange(e)} className="mt-16"/>
                    )
                }
            </div>

            {
                (level.sing_up_type && !isEmpty(fields.captcha.token) && fields.captcha.require) ?
                    <Captcha
                        handleChange={handleCaptchaChange}
                        token={fields.captcha.token}
                        error={fields.captcha_code.error}
                        captchaValue={fields.captcha.value}
                        handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                        className="mt-24"
                    />
                    : ''
            }

            <ButtonBase disabled={fields.sing_up_type.loading} onClick={() => handleSingUp()} color="secondary" block className={"mt-24 "}>
                {
                    (fields.sing_up_type.loading) ?
                        <CircleLoading width={24} height={24}/>
                        :
                        'ادامه'
                }
            </ButtonBase>

            <div className="mt-40 text-center">
                <p>
                    <span>با ثبت‌نام، </span>
                    <a href="/ضوابط-قوانین" target="_blank" className="text-secondary">
                        قوانین ۲نبش
                    </a>
                    <span> رو می‌پذیرم!</span>
                </p>
            </div>
        </Container>
    )
}

export default SignUpType;

// styles
const Container = styled.div`
  display: ${props => props.show ? 'block' : 'none'};

`;